import vue from "../main";
import isEmail from "validator/lib/isEmail";
//export const passwordRegexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+`~=\-[\]\\{};:"'/?.>,<]).{8,}$/;
const specialCharactersRegex = /^(?=.*[!@#$%^&*()_+`~=\-[\]\\{};:"'/?.>,<])/;
const digitRegex = /^(?=.*\d)/;
const lowerLettersRegex = /^(?=.*[a-z])/;
const upperLettersRegex = /^(?=.*[A-Z])/;
export const passwordRules = [
  v => !!v || vue.$t("user.validation.passwordIsRequired"),
  //v => passwordRegexp.test(v) || vue.$t("user.validation.passwordLength"),
  v =>
    vue.$store.getters["userProperties"] === null ||
    v.length >= vue.$store.getters["userProperties"].system_settings.minimum_password_length ||
    vue.$t("user.validation.length"),
  v =>
    vue.$store.getters["userProperties"] === null ||
    vue.$store.getters["userProperties"].system_settings.special_characters_required_in_password === 1 ||
    specialCharactersRegex.test(v) ||
    vue.$t("user.validation.specialChars"),
  v =>
    vue.$store.getters["userProperties"] === null ||
    vue.$store.getters["userProperties"].system_settings.digits_required_in_password === 1 ||
    digitRegex.test(v) ||
    vue.$t("user.validation.digits"),
  v =>
    vue.$store.getters["userProperties"] === null ||
    vue.$store.getters["userProperties"].system_settings.lower_letters_required_in_password === 1 ||
    lowerLettersRegex.test(v) ||
    vue.$t("user.validation.lower"),
  v =>
    vue.$store.getters["userProperties"] === null ||
    vue.$store.getters["userProperties"].system_settings.upper_letters_required_in_password === 1 ||
    upperLettersRegex.test(v) ||
    vue.$t("user.validation.upper")
];

export default class User {
  id = null;
  name = "";
  surname = "";
  login = "";
  email = "";
  password = "";
  repeatPassword = "";
  sex = 0;
  password_by_mail = false;
  home_address_id = null;
  work_address_id = null;
  superior_user_id = null;
  organization_structure_id = null;
  vehicle_private_id = null;
  vehicle_default_id = null;
  cost_centre = null;
  bank_name = null;
  bank_account_number = null;
  group_id = null;
  integration_identifier = null;
  group_name = "";
  vehicle_private_name = "";
  vehicle_default_name = "";
  superior_user_name = "";
  language = "pl-PL";
  phone = "";
  document_number = null;
  birth_date = null;
  document_expire = null;
  middle_name = null;
  nationality = null;
  document_issue_place = null;
  residence_address = null;
  is_notify_new_travel_service_response = false;

  auth_items = [];

  nameRules = [v => (v != null && v.length > 0) || vue.$t("user.validation.nameIsRequired")];
  surnameRules = [v => (v != null && v.length > 0) || vue.$t("user.validation.surnameIsRequired")];
  emailRules = [
    v => (v != null && v.length > 0) || vue.$t("user.validation.emailIsRequired"),
    v => v === null || isEmail(v) || vue.$t("user.validation.emailMustBeValid")
  ];
  loginRules = [
    v => (v != null && v.length > 0) || vue.$t("user.validation.loginIsRequired"),
    v => v.length >= 6 || vue.$t("user.validation.loginMustBeValid")
  ];
  passwordRules = passwordRules;
  repeatPasswordRules = [
    //v => ((!!v)&&id!=null) || 'Hasło jest wymagane',
    v => v === this.password || vue.$t("user.validation.repeatPassword")
  ];
  phoneNumberRules = [v => (v != null && v.length > 0) || vue.$t("global.error.required"), v => v.length === 11 || vue.$t("global.error.badPhoneNumber")];

  constructor(userId = null, loadUrl = null) {
    if (userId != null) {
      if (loadUrl != null) {
        this.load(userId, loadUrl);
      } else {
        this.load(userId);
      }
    } else {
      if (!vue.$store.getters["isAdmin"]) {
        vue.axios.get("settings/role-mapping/mapping-default-user-details").then(resp => {
          if (this.id == null) {
            this.auth_items = resp.data.auth_items;
          }
        });
      }
    }
  }

  load(userId, loadUrl = "settings/user/user-details") {
    vue.axios.get(loadUrl, { params: { id: userId } }).then(resp => {
      this.id = resp.data.user_form.id;
      this.name = resp.data.user_form.name;
      this.surname = resp.data.user_form.surname;
      this.email = resp.data.user_form.email;
      this.login = resp.data.user_form.login;
      this.auth_items = resp.data.auth_items;
      this.sex = resp.data.user_form.sex;
      this.home_address_id = resp.data.user_form.home_address_id;
      this.home_address_name = resp.data.user_form.formatted_home_address;
      this.work_address_id = resp.data.user_form.work_address_id;
      this.work_address_name = resp.data.user_form.formatted_work_address;
      this.superior_user_id = resp.data.user_form.superior_user_id;
      this.organization_structure_id = resp.data.user_form.organization_structure_id;
      this.vehicle_private_id = resp.data.user_form.vehicle_private_id;
      this.vehicle_default_id = resp.data.user_form.vehicle_default_id;
      this.cost_centre = resp.data.user_form.cost_centre;
      this.bank_name = resp.data.user_form.bank_name;
      this.bank_account_number = resp.data.user_form.bank_account_number;
      this.group_id = resp.data.user_form.group_id;
      this.integration_identifier = resp.data.user_form.integration_identifier;
      this.group_name = resp.data.user_form.group_name;
      this.vehicle_private_name = resp.data.user_form.vehicle_private_name;
      this.vehicle_default_name = resp.data.user_form.vehicle_default_name;
      this.superior_user_name = resp.data.user_form.superior_user_name;
      this.language = resp.data.user_form.language;
      this.phone = resp.data.user_form.phone;
      this.document_number = resp.data.user_form.document_number;
      this.birth_date = resp.data.user_form.birth_date;
      this.middle_name = resp.data.user_form.middle_name;
      this.nationality = resp.data.user_form.nationality;
      this.document_issue_place = resp.data.user_form.document_issue_place;
      this.residence_address = resp.data.user_form.residence_address;
      this.document_expire = resp.data.user_form.document_expire;
      this.is_notify_new_travel_service_response = resp.data.user_form.is_notify_new_travel_service_response;
    });
  }

  save(saveUrl = "settings/user/user-save") {
    return new Promise((resolve, reject) => {
      vue.axios
        .post(saveUrl, this)
        .then(() => {
          resolve();
        })
        .catch(resp => {
          reject(resp.data);
        });
    });
  }
}
